import { render, staticRenderFns } from "./ViewCompanies.vue?vue&type=template&id=0972be10&scoped=true"
import script from "./ViewCompanies.vue?vue&type=script&lang=js"
export * from "./ViewCompanies.vue?vue&type=script&lang=js"
import style0 from "./ViewCompanies.vue?vue&type=style&index=0&id=0972be10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972be10",
  null
  
)

export default component.exports